
import { getPOD } from '@/api';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class POD extends Vue {
  @Prop({ type: Boolean, required: true }) private readonly pod!: boolean;
  @Prop({ type: Number, required: true }) private readonly id!: number;
  @Prop({ type: String }) private readonly uniqueId!: string;
  @Prop({ type: String, required: true }) private readonly date!: string;
  @Prop({ type: Number, required: true }) private readonly idx!: number;
  @Prop(String) private readonly name!: string;

  private url: string | Blob = '';
  private loading = false;

  @Watch('uniqueId', { immediate: true })
  private updatePOD() {
    this.url = '';
    if (this.pod) {
      this.loading = true;
      getPOD(this.id, this.date, this.idx + 1)
        .then(img => {
          if (img !== 'Not found') {
            this.url = img;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
